import Chart from "react-apexcharts";
import { Skeleton } from "@mui/material";
import { DashCard } from "./DashCard";
import { chartColors, fontFamily } from "../../data/tokens";
import { MemberStatusCounts } from "./useDashboardData";

export function MembersStatusDonut({
  counts,
}: {
  counts: MemberStatusCounts | null;
}) {
  return (
    <DashCard title="Sócios por situação">
      {!counts ? (
        <Skeleton variant="circular" width={220} height={220} sx={{ mx: "auto", my: 3 }} />
      ) : (
        <Chart
          type="donut"
          height={320}
          series={[
            counts.active,
            counts.canceled,
            counts.deceased,
            counts.noContact,
            counts.licensed,
            counts.pending,
            counts.unknown,
          ]}
          options={{
            // Rótulos puros: a contagem entra pela legenda (formatter) e
            // pelo tooltip — embutida no label, o hover duplicava o
            // número ("Falecidos: 3.334: 3334")
            labels: [
              "Ativos",
              "Cancelados",
              "Falecidos",
              "Sem Contato",
              "Licenciados",
              "Pendentes",
              "Não Informado",
            ],
            colors: chartColors,
            chart: { fontFamily, toolbar: { show: false } },
            dataLabels: { dropShadow: { enabled: false } },
            plotOptions: { pie: { donut: { size: "58%" } } },
            legend: {
              position: "bottom",
              formatter: (seriesName: string, opts: any) =>
                `${seriesName}: ${Number(
                  opts.w.globals.series[opts.seriesIndex]
                ).toLocaleString("pt-BR")}`,
            },
            tooltip: {
              y: {
                formatter: (val: number) =>
                  Number(val).toLocaleString("pt-BR"),
              },
            },
          }}
        />
      )}
    </DashCard>
  );
}
